module.exports = __webpack_public_path__ + "static/media/social-distancing.542c4a89.png";